import React from 'react';
import './Home1.css';
import HomeBody from '../HomeBody';
import Footer from '../Footer';

function Home() {
    return (
      <>
      <HomeBody />
      <Footer />
      </>
    )
}

export default Home;